<template>
    <div class="common_table_container">
        <el-table
            :cell-style="type_style"
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange">
            <el-table-column
            type="selection"
            width="55">
            </el-table-column>
            <!-- <el-table-column v-for="(val,index) in table_title_list" :key="index"
            :prop="val.prop"
            :label="val.label">
            </el-table-column> -->
            <el-table-column v-for="(val,index) in table_title_list" :key="index" :prop="val.prop"
            :label="val.label">
                <template slot-scope="scope">
                    <div :class="val.label == '类型名称'?'doc':''" @click="cell_jump(scope.row.id)">
                       <span>{{scope.row[val.prop]}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column v-if="modular=='resources'" prop="face_pic" label="封面图">
                <template slot-scope="scope">
                    <el-image style="width: 100px; height: 130px" :src="scope.row.face_pic" fit="cover"></el-image>
                </template>
            </el-table-column>
            <el-table-column
            fixed="right"
            label="操作"
            width="100">
            <template slot-scope="scope">
                <el-popconfirm
                title="确定删除吗？" @confirm="handleClick(scope.row)"
                >
                    <el-button slot="reference" type="text" size="small" v-if="modular=='type'?hasAccess('251'):hasAccess('247')">删除</el-button>
                </el-popconfirm>
                <el-button type="text" size="small" v-if="modular=='type'?hasAccess('250'):hasAccess('246')" @click="open_dialogVisible(scope.row)">编辑</el-button>
            </template>
            </el-table-column>
        </el-table>
        <CommonTopGo v-if="is_show_top" @backtop="backtop"/>
    </div>
</template>

<script>
import CommonTopGo from "@/components/common_top/common_top.vue"
import { hasAccess } from '@/common/utils'
import { mapState, mapGetters, mapActions } from "vuex";
export default {
    props:{
        tableData:{
            type:Array
        },
        table_title_list:{
            type:Array
        },
        modular:{
            type:String
        }
    },
    components:{
        CommonTopGo
    },
    data(){
        return{
            hasAccess,
            multipleSelection: [],
            ids_val:'',
            is_show_top:false
        }
    },
    computed:{
        ...mapGetters("type_tube_vuex",['ids']),
        ...mapGetters("resources_tube_vuex",['resources_ids'])
    },
    mounted(){
        this.$refs.multipleTable.bodyWrapper.addEventListener('scroll', (e) => {
            if(e.target.scrollTop>=500){
                this.is_show_top = true
            }else{
                this.is_show_top = false
            }	
        })
    },
    methods:{
        ...mapActions("type_tube_vuex",['get_type_list']),
        backtop(){
            this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
        },
        cell_jump(id){
            this.$router.push({path:'/resources_tube',query:{id:id}});
        },
        type_style(column) {
            if(column.column.id == 'el-table_1_column_1') {
                return "color: red"
            }
        },
        // cell_click(row, column, event) {
        //     if(column.label == '类型名称'){
        //         this.$router.push({path:'/resources_tube',query:{id:row.id}});
        //     }
        // },
        handleSelectionChange(list){
            this.ids_val = ''
            list.forEach(element => {
                this.ids_val += element.id+','
            });
            this.ids_val = this.ids_val.slice(0,this.ids_val.length-1)
            if(this.modular == 'type'){
                this.$store.commit("type_tube_vuex/set_ids_vuex",this.ids_val)
            }else if(this.modular == 'resources'){
                this.$store.commit("resources_tube_vuex/set_resources_ids_vuex",this.ids_val)
            }
        },
        handleClick(val){
            this.$emit('single_del',val)
        },
        open_dialogVisible(val){
            console.log(val,'hshjsh')
            switch (this.modular) {
                case 'resources':
                    this.$emit('open_dialogVisible',val)
                    break;
                case 'type':
                    let data = {
                        id:val.id,
                        name:val.name,
                        sort_weight:val.sort_weight
                    }
                    this.$emit('open_dialogVisible',data)
                default:
                    break;
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.common_table_container{
    .doc{
        color: rgb(0, 119, 255);
        cursor:pointer;
        span:hover{
            border-bottom: 1px solid rgb(0, 119, 255);
            transition: 1s;
        }
    }
}
</style>